import { LogLevels } from '@powersync/common';
import { AbstractRemote } from '@powersync/shared-internals';
import { getUserAgentInfo } from './userAgent.js';
export class WebRemote extends AbstractRemote {
    connector;
    constructor(connector, logger) {
        super(connector, logger);
        this.connector = connector;
    }
    fetch({ resource, request }) {
        return fetch(resource, request);
    }
    async loadWebSocketSupport(platform) {
        if (!websockets) {
            // loadWebSocketSupport being called concurrently is safe, the import resolves to the same module in that case.
            const module = await import('@powersync/shared-internals/websockets');
            websockets = new module.WebSocketSupport(platform);
        }
        return websockets;
    }
    getUserAgent() {
        let ua = [super.getUserAgent(), `powersync-web`];
        try {
            ua.push(...getUserAgentInfo());
        }
        catch (error) {
            this.logger.log({ level: LogLevels.warn, message: 'Failed to get user agent info', error });
        }
        return ua.join(' ');
    }
}
let websockets;
//# sourceMappingURL=WebRemote.js.map